import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import $ from 'jquery';

class Playlists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customPlaylists: '',
      customPlaylistHTML: '<button class="list-group-item divider my-playlists">My Playlists</button> <button id="add-new-playlist" data-id="'+this.props.account+'" data-toggle="tooltip" data-placement="right" title="Create a new playlist"><i class="fa fa-plus-circle add-new-playlist" aria-hidden="true"></i></button>',
    }
    this.showPlaylists = this.showPlaylists.bind(this);
    this.firePlaylistChange = this.firePlaylistChange.bind(this);
  }

  showPlaylists() {
    let $pinned = localStorage.getItem('pinnedPlaylistDrawer');
    if ($pinned !== '1') {
      $('#playlists, #playlists .playlist-toggle .toggle, #jukebox, #catalog, a.navbar-brand').toggleClass('show');
    }
  }

  firePlaylistChange() {
    $('#playlists button.list-group-item span.clear-friend-list').on('click touchend', function() {
      localStorage.removeItem('friendID');
      var uri = window.location.toString();
      if (uri.indexOf("?") > 0) {
        var clean_uri = uri.substring(0, uri.indexOf("?"));
        window.history.replaceState({}, document.title, clean_uri);
      }
      //window.location.reload();
      document.location.href="/";
    });
    $('#playlists button.list-group-item.playlist').on('click touchend', function() {
      let playlistName = $(this).data('playlist'),
          playlistTitle = $(this).data('name');
      $('#playlists button.active').removeClass('active');
      $(this).addClass('active');
      if (playlistName === 'custom') {
        let playlistID = $(this).data('id');
        localStorage.setItem('curPlaylistID', playlistID);
        //make a call to updatePlaylist
        //var uri = window.location.toString();
        //if (uri.indexOf("?") > 0) {
          //var clean_uri = uri.substring(0, uri.indexOf("?"));
          //window.history.replaceState({}, document.title, clean_uri);
        //}
        //window.location.reload();
        document.location.href="/";
      } else if (playlistName === 'custom-friend') {
        let friendID = localStorage.getItem('friendID');
        if (!friendID) {
          friendID = $('button.friend-playlists').data('id').substring(3);
          localStorage.setItem('friendID', friendID);
        }
        let playlistID = $(this).data('id');
        localStorage.setItem('curPlaylistID', playlistID);
        //make a call to updatePlaylist
        if (friendID) {
          //var uri = window.location.toString();
          window.history.replaceState({}, document.title, '?connection='+friendID+'&id='+playlistID);
        }
        //window.location.reload();
        document.location.href="/";
      } else if (playlistName === 'favorites') {
        localStorage.setItem('curPlaylistID', '00');
        //make a call to updatePlaylist
        //window.location.reload();
        document.location.href="/";
      } else {
        localStorage.setItem('curPlaylistID', 0);
        //var uri = window.location.toString();
        //if (uri.indexOf("?") > 0) {
          //var clean_uri = uri.substring(0, uri.indexOf("?"));
          //window.history.replaceState({}, document.title, clean_uri);
        //}
      }
      localStorage.setItem('curPlaylist', playlistName);
      localStorage.setItem('curPlaylistTitle', playlistTitle);
      //$('.react-jinke-music-player-main .audio-lists-panel').removeClass('hide').addClass('show');
      $('#playlists .playlist-toggle .toggle.fa-times').removeClass('show');
      $('#playlists .playlist-toggle .toggle.fa-music').addClass('show');
      $('#playlists, #jukebox, #catalog, a.navbar-brand').removeClass('show');
    });
  }

  componentDidMount() {
    let formData = new FormData();
    formData.append('task', 'custom_playlists');
    formData.append('friendID', this.props.friendID);
    formData.append('userid', this.props.userid);
    formData.append('auth_token', this.props.auth_token);
    return fetch('https://www.d-cot.com/api/jukebox/', {
      method: 'POST',
      mode: 'cors',
      headers:{
        'Access-Control-Allow-Origin':'*'
      },
      body: formData
      })
      .then((response) => response.json())
      .then((responseJson) => {
        let data = responseJson;
        if (data[0].not_auth === 'fail') {
          window.location = '/';
        }
        if (data) {
          for (let key of Object.keys(data)) {
            let customPlaylistName = data[key],
                customPlaylistHTML = '';
            if (customPlaylistName.playlistCustomID.startsWith('00-')) {
              customPlaylistHTML = '<button class="list-group-item divider friend-playlists" data-playlist="custom" data-name="'+customPlaylistName.playlistCustomName+'" data-id="'+customPlaylistName.playlistCustomID+'">'+customPlaylistName.playlistCustomName+' <span class="clear-friend-list" title="Remove Friend\'s Playlists"><i class="fa fa-times"></i></span></button>';
            } else if (customPlaylistName.playlistCustomFriendID) {
              customPlaylistHTML = '<button class="list-group-item playlist custom-playlist d-flex justify-content-between align-items-center" data-playlist="custom-friend" data-name="'+customPlaylistName.playlistCustomName+'" data-id="'+customPlaylistName.playlistCustomID+'">'+customPlaylistName.playlistCustomName+'</button>';
            } else if (customPlaylistName.playlistCustomID === '00') {
              customPlaylistHTML = '<button class="list-group-item playlist custom-playlist user-playlist d-flex justify-content-between align-items-center" data-playlist="favorites" data-name="'+customPlaylistName.playlistCustomName+'" data-id="'+customPlaylistName.playlistCustomID+'">'+customPlaylistName.playlistCustomName+'</button>';
            } else {
              customPlaylistHTML = '<button class="list-group-item playlist custom-playlist user-playlist d-flex justify-content-between align-items-center" data-playlist="custom" data-name="'+customPlaylistName.playlistCustomName+'" data-id="'+customPlaylistName.playlistCustomID+'">'+customPlaylistName.playlistCustomName+'<div class="remove-custom-playlist" data-toggle="tooltip" data-placement="right" title="Delete this playlist"><i class="fa fa-minus" aria-hidden="true"></i></div></button>';
            }
            this.setState({
              customPlaylistHTML: this.state.customPlaylistHTML+customPlaylistHTML,
              customPlaylistData: data
            });
          }
        }

        $('.playlist-names').prepend(this.state.customPlaylistHTML);
        if (localStorage.getItem('curPlaylist') === 'custom') {
          $('#playlists button.active').removeClass('active');
          $('#playlists button[data-id='+localStorage.getItem('curPlaylistID')+']').addClass('active');
        }

        if (localStorage.getItem('curPlaylist')) {
          $('#playlists a.active').removeClass('active');
          if (localStorage.getItem('curPlaylist') === 'custom') {
              $('#playlists a[data-id='+localStorage.getItem('curPlaylistID')+']').addClass('active');
          } else {
              $('#playlists a[data-playlist='+localStorage.getItem('curPlaylist')+']').addClass('active');
          }
        }

        $('.remove-custom-playlist').on('click touchend', function(e){
          let $playlistName = $(this).parent().data('name'),
              $playlistID = $(this).parent().data('id');
          e.preventDefault();
          e.stopPropagation();
          $('.modal .modal-title').html('<i class="fa fa-music" aria-hidden="true"></i> Delete Custom Playlist');
          $('.modal .modal-body').html('<h5>' + $playlistName + '</h5><div class="alert alert-danger" role="alert" style="margin: 10px 0 0 0;">If you delete this playlist you will lose all songs associated with it. This is not recoverable.</div>');
          $('.modal .modal-footer').html('<button type="button" class="btn btn-secondary close-remove-custom-playlist" data-dismiss="modal">Close</button><button type="button" class="btn btn-primary remove-custom-playlist-action" data-dismiss="modal">Remove</button>');
          $('.modal').modal();

          $('.remove-custom-playlist-action').on('click touchend', function(e){
            //remove custom playlist
            let formData = new FormData();
            formData.append('playlistID', $playlistID);
            formData.append('task', 'remove_playlist');
            formData.append('userid', localStorage.getItem('userid'));
            formData.append('auth_token', localStorage.getItem('auth_token'));
            return fetch('https://www.d-cot.com/api/jukebox/', {
              method: 'POST',
              mode: 'cors',
              headers:{
                'Access-Control-Allow-Origin':'*'
              },
              body: formData
              })
              .then((response) => response.json())
              .then((responseJson) => {
                let data = responseJson;
                if (data) {
                  if (data[0].status === 'success') {
                    $('.modal .modal-footer button.remove-custom-playlist-action').html('Removed <i class="fa fa-check" aria-hidden="true"></i>');
                    $('.modal .modal-footer button.close-remove-custom-playlist').prop('disabled',false);
                    $('.modal').modal('hide');
                    //window.location.reload();
                    window.location.href = '/?rp=success';
                  } else {
                    $('.modal .modal-body .alert').html('There was an error. Please try again later.').slideDown();
                    $('.modal .modal-footer button.remove-custom-playlist-action').html('Remove');
                    $('.modal .modal-footer button.close-remove-custom-playlist').prop('disabled',false);
                    $('.modal .modal-footer button.remove-custom-playlist-action').prop('disabled',true);
                  }
                }
              })
              .catch((error) => {
                console.error(error);
                $('.modal .modal-body .alert').html('There was an error. Please try again later.').slideDown();
                $('.modal .modal-footer button.create-new-playlist').html('Create');
                $('.modal .modal-footer button.close-create-new-playlist').prop('disabled',false);
                $('.modal .modal-footer button.create-new-playlist, #add-song').prop('disabled',true);
              });
          });
        });

        $('#pin-playlists').on('click touchend', function(){
          let $pinned = localStorage.getItem('pinnedPlaylistDrawer');
          if ($pinned === '0' || !$pinned) {
            localStorage.setItem('pinnedPlaylistDrawer', 1);
            $(this).addClass('pinned');
            $('#playlists, #jukebox, .playlist-toggle .ico-close, #catalog, a.navbar-brand').addClass('pinned');
            console.log('pinned');
            toast.success('The playlist drawer has been pinned.', {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else if ($pinned === '1') {
            localStorage.setItem('pinnedPlaylistDrawer', 0);
            $(this).removeClass('pinned');
            $('#playlists, #jukebox, .playlist-toggle .ico-close, #catalog, a.navbar-brand').removeClass('pinned');
            $('a.navbar-brand, #playlists, .toggle.ico-close').removeClass('show');
            $('.toggle.ico-open').addClass('show');
            console.log('unpinned');
            toast.success('The playlist drawer has been unpinned.', {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });

        $('#add-new-playlist').on('click touchend', function(){
          let $account = $(this).data('id');
          $('.modal .modal-title').html('<i class="fa fa-music" aria-hidden="true"></i> Create New Playlist');
          if ($account === 0) { //if they are not a supporter
            $('.modal .modal-body').html('<div><p>You need to be a supporter in order to create custom playlists. <a href="https://www.d-cot.com/become-a-supporter/" target="_blank" rel="noopener nofollow">Check out the perks on joining</a>!</p></div><div class="alert alert-danger" role="alert" style="display: none; margin: 10px 0 0 0;"></div>');
            $('.modal .modal-footer').html('<button type="button" class="btn btn-secondary close-create-new-playlist" data-dismiss="modal">Close</button>');
          } else {
            $('.modal .modal-body').html('<div><input type="text" id="create-new-playlist" class="form-control"></div><div class="alert alert-danger" role="alert" style="display: none; margin: 10px 0 0 0;"></div>');
            $('.modal .modal-footer').html('<button type="button" class="btn btn-secondary close-create-new-playlist" data-dismiss="modal">Close</button><button type="button" class="btn btn-primary create-new-playlist">Create</button>');
          }
          $('.modal').modal();

          $('#playlists .playlist-toggle .toggle.fa-times').removeClass('show');
          $('#playlists .playlist-toggle .toggle.fa-music').addClass('show');
          $('#playlists, #jukebox, #catalog, a.navbar-brand').removeClass('show');

          $('.create-new-playlist').on('click touchend', function(e){
            e.stopImmediatePropagation();
            if(e.type === 'touchend'){
              $(this).off('click');
            }
            let $newPlaylist = $('#create-new-playlist').val();
            if (!$newPlaylist) { //no playlist or create new playlist
              $('.modal .modal-body .alert').html('Please provide a name for your playlist.').slideDown();
            } else if ($newPlaylist) { //no playlist and create new playlist
              let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
              if (format.test($newPlaylist) === false && $newPlaylist.length <= 40) {
                //create new playlist and then add song to it
                $('.modal .modal-footer button.close-create-new-playlist').prop('disabled',true);
                $('.modal .modal-footer button.create-new-playlist').html('Creating <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>');

                //create new playlist fetch here
                let formData2 = new FormData();
                formData2.append('newPlaylist', $newPlaylist);
                formData2.append('task', 'create_playlist');
                formData2.append('userid', localStorage.getItem('userid'));
                formData2.append('auth_token', localStorage.getItem('auth_token'));
                return fetch('https://www.d-cot.com/api/jukebox/', {
                  method: 'POST',
                  mode: 'cors',
                  headers:{
                    'Access-Control-Allow-Origin':'*'
                  },
                  body: formData2
                  })
                  .then((response) => response.json())
                  .then((responseJson) => {
                    let data = responseJson;
                    if (data) {
                      if (data[0].status === 'success') {
                        $('.modal .modal-footer button.create-new-playlist').html('Created <i class="fa fa-check" aria-hidden="true"></i>');
                        $('.modal .modal-footer button.close-create-new-playlist').prop('disabled',false);
                        $('.modal').modal('hide');
                        //window.location.reload();
                        window.location.href = '/?np=success';
                        //SRA trying to just refresh custom playlist list in playlist selector
                        /*let formData = new FormData();
                        formData.append('task', 'custom_playlists');
                        formData.append('userid', localStorage.getItem('userid'));
                        formData.append('auth_token', localStorage.getItem('auth_token'));
                        return fetch('https://www.d-cot.com/api/jukebox/', {
                          method: 'POST',
                          mode: 'cors',
                          headers:{
                            'Access-Control-Allow-Origin':'*'
                          },
                          body: formData
                          })
                          .then((response) => response.json())
                          .then((responseJson) => {
                            let data = responseJson;
                            if (data) {
                              let loopData = '',
                                  i;
                              $('#playlists .custom-playlist').remove();
                              for(i=0; i < data.length; i++){
                                if (`${data[i].playlistCustomID}` === '00') {
                                  loopData += `<button class="list-group-item playlist custom-playlist user-playlist d-flex justify-content-between align-items-center" data-playlist="favorites" data-name="${data[i].playlistCustomName}" data-id="${data[i].playlistCustomID}">${data[i].playlistCustomName}</button>`;
                                } else {
                                  loopData += `<button class="list-group-item playlist custom-playlist user-playlist d-flex justify-content-between align-items-center" data-playlist="custom" data-name="${data[i].playlistCustomName}" data-id="${data[i].playlistCustomID}">${data[i].playlistCustomName}</button>`;
                                }
                              }
                              $('#playlists #add-new-playlist').after(loopData);
                            }
                        })
                        .catch((error) => {
                          console.error(error);
                        });*/
                      } else {
                        $('.modal .modal-body .alert').html('There was an error. Please try again later.').slideDown();
                        $('.modal .modal-footer button.create-new-playlist').html('Create');
                        $('.modal .modal-footer button.close-create-new-playlist').prop('disabled',false);
                        $('.modal .modal-footer button.create-new-playlist, #create-new-playlist').prop('disabled',true);
                      }
                    }
                  })
                  .catch((error) => {
                    console.error(error);
                    $('.modal .modal-body .alert').html('There was an error. Please try again later.').slideDown();
                    $('.modal .modal-footer button.create-new-playlist').html('Create');
                    $('.modal .modal-footer button.close-create-new-playlist').prop('disabled',false);
                    $('.modal .modal-footer button.create-new-playlist, #add-song').prop('disabled',true);
                  });
              } else {
                $('.modal .modal-body .alert').html('Your playlist name either contains special characters or is greater than 40 characters. Please only user letters, numbers and spaces.').slideDown().delay(10000).slideUp();
              }
            }
          });
        });

        this.firePlaylistChange();
    })
    .catch((error) => {
      console.error(error);
    });
  }

  render() {
    return (
      <div id="playlists" className="">
        <div onClick={this.showPlaylists} className="playlist-toggle">
          <i className="toggle ico-close fa fa-times" aria-hidden="true"></i>
          <i className="toggle ico-open show fa fa-music" aria-hidden="true"></i>
        </div>
        <div className="list-group list-group-flush">
          <div className="audio-lists-panel-header">
            <h4 className="title">Playlists</h4>
            <div id="pin-playlists" data-toggle="tooltip" data-placement="right" title="Pin this drawer"><i className="fa fa-thumb-tack" aria-hidden="true"></i></div>
          </div>
          <div className="playlist-names">
            <button className="list-group-item divider">Compilations</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="newest" data-name="Newest Additions">Newest Additions</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="top25week" data-name="Top 25 Played Week">Top 25 Played Week</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="top25played" data-name="Top 25 Played Overall">Top 25 Played Overall</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="top25rated" data-name="Top 25 Rated">Top 25 Rated</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="random" data-name="Random 25">Random 25</button>
            <button className="list-group-item divider">Walt Disney World</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="magic_kingdom" data-name="Magic Kingdom">Magic Kingdom</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="epcot" data-name="Epcot">Epcot</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="hollywood_studios" data-name="Disney's Hollywood Studios">Hollywood Studios</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="animal_kingdom" data-name="Disney's Animal Kingdom">Animal Kingdom</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="typhoon_lagoon" data-name="Typhoon Lagoon">Typhoon Lagoon</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="blizzard_beach" data-name="Blizzard Beach">Blizzard Beach</button>
            <button className="list-group-item divider">Disneyland</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="disneyland_park" data-name="Disneyland Park">Disneyland Park</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="california_adventure" data-name="Disney's California Adventure">California Adventure</button>
            <button className="list-group-item playlist divider">Disney Around the World</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="disneyland_paris" data-name="Disneyland Paris">Disneyland Paris</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="hong_kong" data-name="Hong Kong Disneyland">Hong Kong Disneyland</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="shanghai" data-name="Shanghai Disneyland">Shanghai Disneyland</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="tokyo_disney" data-name="Tokyo Disney Resort">Tokyo Disney Resort</button>
            <button className="list-group-item divider">Resorts</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="all_star" data-name="All-Star Resorts">All-Star Resorts<span className="badge badge-success">New</span></button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="animal_kingdom_lodge" data-name="Animal Kingdom Lodge">Animal Kingdom Lodge</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="boardwalk" data-name="Disney's BoardWalk Inn">BoardWalk Inn</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="caribbean_beach" data-name="Caribbean Beach Resort">Caribbean Beach Resort</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="contemporary" data-name="Contemporary">Contemporary <span className="badge badge-success">New</span></button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="coronado_springs" data-name="Coronado Springs">Coronado Springs</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="disneyland_hotel" data-name="Disneyland Hotel">Disneyland Hotel</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="grand_californian" data-name="Grand Californian">Grand Californian</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="grand_floridian" data-name="Grand Floridian">Grand Floridian</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="old_key_west" data-name="Old Key West">Old Key West</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="polynesian" data-name="Polynesian">Polynesian</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="port_orleans" data-name="Port Orleans">Port Orleans</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="resort_tv" data-name="Resort TV">Resort TV</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="riviera" data-name="Riviera Resort">Riviera Resort <span className="badge badge-success">New</span></button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="saratoga_springs" data-name="Disney's Saratoga Springs">Saratoga Springs</button> 
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="transportation" data-name="Transportation">Transportation</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="wilderness_lodge" data-name="Wilderness Lodge">Wilderness Lodge</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="yacht_beach" data-name="Transportation">Yacht &amp; Beach Club</button>
            <button className="list-group-item divider">Holidays</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="christmas" data-name="Christmas">Christmas</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="halloween" data-name="Halloween">Halloween</button>
            <button className="list-group-item divider">Mouse-ellaneous</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="disney_cruise_line" data-name="Disney Cruise Line">Disney Cruise Line</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="misc" data-name="Disney-Related Audio">Disney-Related Audio</button>
            <button onClick={this.props.updatePlaylist} className="list-group-item playlist d-flex justify-content-between align-items-center" data-playlist="monorail" data-name="Monorail">Monorail</button>
          </div>
        </div>
      </div>
    );
  }
}

export default Playlists;
